import DialogPromise from "./src/DialogPromise";
export default DialogPromise;